import { UserEffects } from './user.effects';
import { NetworkEffects } from './network.effects';

export const appEffects: any[] = [UserEffects, NetworkEffects];
